window.productItemSlider = (() => {

  const observed_elements = new WeakSet();
  let mutation_timer;

  const is_touch_device = window.matchMedia('(hover: none)').matches;

  const loadSlideImage = (slide) => {
    const img = slide.querySelector('img[data-src]');
    if (!img) return;

    slide.querySelectorAll('source[data-srcset]').forEach(source => {
      source.srcset = source.dataset.srcset;
    });

    img.src = img.dataset.src;
    img.removeAttribute('data-src');
  };

  const initSlider = (product_item) => {
    if (product_item.classList.contains('product-item--slider-activated')) return;

    const slider_el = product_item.querySelector('[data-product-slider]');
    const track = product_item.querySelector('[data-slider-track]');
    const dots_container = product_item.querySelector('[data-slider-dots]');
    if (!track) return;

    const slides = [...track.querySelectorAll('[data-slide]')];
    if (slides.length <= 1) return;

    const slide_time = parseInt(slider_el?.dataset.slideTime) || 3000;
    const transition_speed = parseInt(slider_el?.dataset.transitionSpeed) || 350;

    let current_index = 0;
    let autoplay_timer;
    let touch_start_x = 0;
    let pointer_start_x = 0;
    let prevent_next_click = false;

    const savePosition = () => {
      product_item.dataset.currentSlide = current_index;
    };

    const updateDots = () => {
      if (!dots_container) return;
      dots_container.querySelectorAll('.product-item__slider-dot').forEach((dot, i) => {
        dot.classList.toggle('is-active', i === current_index);
      });
    };

    const getSlideWidth = () => slider_el.getBoundingClientRect().width;

    const goToSlide = (index) => {
      current_index = (index + slides.length) % slides.length;
      track.style.transform = `translateX(${-current_index * getSlideWidth()}px)`;
      loadSlideImage(slides[current_index]);
      loadSlideImage(slides[(current_index + 1) % slides.length]);
      updateDots();
      savePosition();
    };

    const goToSaved = () => {
      const saved = parseInt(product_item.dataset.currentSlide) || 1;
      current_index = saved;
      track.style.transition = 'none';
      track.style.transform = `translateX(${-current_index * getSlideWidth()}px)`;
      loadSlideImage(slides[current_index]);
      loadSlideImage(slides[(current_index + 1) % slides.length]);
      updateDots();
      requestAnimationFrame(() => {
        track.style.transition = `transform ${transition_speed}ms ease`;
      });
    };

    slides.forEach((_, i) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'product-item__slider-dot' + (i === 0 ? ' is-active' : '');
      dot.setAttribute('aria-label', `Slide ${i + 1}`);
      dot.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        goToSlide(i);
        stopAutoplay();
        startAutoplay();
      });
      dots_container?.appendChild(dot);
    });

    const startAutoplay = () => {
      autoplay_timer = setInterval(() => goToSlide(current_index + 1), slide_time);
    };

    const stopAutoplay = () => clearInterval(autoplay_timer);

    const image_wrapper = product_item.querySelector('.product-item__image-wrapper');

    image_wrapper?.addEventListener('mouseenter', () => {
      if (is_touch_device) return;
      goToSaved();
      startAutoplay();
    });

    image_wrapper?.addEventListener('mouseleave', () => {
      if (is_touch_device) return;
      stopAutoplay();
    });

    image_wrapper?.addEventListener('touchstart', (e) => {
      touch_start_x = e.touches[0].clientX;
      document.querySelectorAll('.product-item--slider-active').forEach(el => {
        if (el !== product_item) el.classList.remove('product-item--slider-active');
      });
    }, { passive: true });

    image_wrapper?.addEventListener('touchend', (e) => {
      const delta = touch_start_x - e.changedTouches[0].clientX;
      if (Math.abs(delta) > 40) {
        product_item.classList.add('product-item--slider-active');
        goToSlide(delta > 0 ? current_index + 1 : current_index - 1);
        stopAutoplay();
        startAutoplay();
        prevent_next_click = true;
      }
    }, { passive: true });

    image_wrapper?.addEventListener('click', (e) => {
      if (prevent_next_click) {
        e.preventDefault();
        prevent_next_click = false;
      }
    });

    const prev_btn = product_item.querySelector('[data-slider-prev]');
    const next_btn = product_item.querySelector('[data-slider-next]');

    prev_btn?.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      goToSlide(current_index - 1);
      stopAutoplay();
      startAutoplay();
    });

    next_btn?.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      goToSlide(current_index + 1);
      stopAutoplay();
      startAutoplay();
    });

    track.addEventListener('pointerdown', (e) => {
      if (e.pointerType !== 'mouse') return;
      pointer_start_x = e.clientX;
      track.setPointerCapture(e.pointerId);
      e.preventDefault();
    });

    track.addEventListener('pointerup', (e) => {
      if (e.pointerType !== 'mouse') return;
      const delta = pointer_start_x - e.clientX;
      if (Math.abs(delta) > 40) {
        goToSlide(delta > 0 ? current_index + 1 : current_index - 1);
        stopAutoplay();
        startAutoplay();
        prevent_next_click = true;
      }
    });

    slider_el.addEventListener('click', (e) => {
      if (prevent_next_click) {
        e.preventDefault();
        e.stopPropagation();
        prevent_next_click = false;
      }
    });

    loadSlideImage(slides[0]);
    loadSlideImage(slides[1]);

    track.style.transition = 'none';
    track.style.transform = `translateX(${-current_index * getSlideWidth()}px)`;
    requestAnimationFrame(() => {
      track.style.transition = `transform ${transition_speed}ms ease`;
    });

    product_item._slider_cleanup = () => stopAutoplay();

    product_item.classList.add('product-item--slider-activated');
  };

  const visibility_observer = new IntersectionObserver((entries) => {
    entries.forEach(({ isIntersecting, target }) => {
      if (!isIntersecting) return;
      initSlider(target);
      visibility_observer.unobserve(target);
    });
  }, { threshold: 0.1, rootMargin: '150px 0px' });

  const observeNewSliders = () => {
    const selector = '.product-item--slider-available:not(.product-item--slider-activated)';
    document.querySelectorAll(selector).forEach(el => {
      if (observed_elements.has(el)) return;
      observed_elements.add(el);
      visibility_observer.observe(el);
    });
  };

  const removeSlider = (product_item) => {
    product_item._slider_cleanup?.();
    product_item.classList.remove('product-item--slider-activated');
    product_item.classList.remove('product-item--slider-active');
    const track = product_item.querySelector('[data-slider-track]');
    if (track) track.style.transform = '';
    const dots = product_item.querySelector('[data-slider-dots]');
    if (dots) dots.innerHTML = '';
  };

  const mutation_observer = new MutationObserver(() => {
    clearTimeout(mutation_timer);
    mutation_timer = setTimeout(observeNewSliders, 80);
  });

  mutation_observer.observe(document.body, { childList: true, subtree: true });

  const init = () => {
    observeNewSliders();
  };

  const regenerate = () => {
    document.querySelectorAll('.product-item--slider-activated').forEach(removeSlider);
    observeNewSliders();
  };

  const remove = () => {
    visibility_observer.disconnect();
    mutation_observer.disconnect();
    document.querySelectorAll('.product-item--slider-activated').forEach(removeSlider);
  };

  init();

  return { init, regenerate, remove };

})();
